// extracted by mini-css-extract-plugin
export var actionText = "_jq-4";
export var container = "_jq-0";
export var leftSection = "_jq-1";
export var rightSection = "_jq-2";
export var settingsButton = "_jq-6";
export var settingsIcon = "_jq-7";
export var shortcut = "_jq-5";
export var shortcutGroup = "_jq-3";